module.exports = __webpack_public_path__ + "static/media/loginimg.ff476624.jpg";